export default {
  getTabs : (state) => { return state.tabs; },
}
